var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "autocomplete-suggestions__position" },
    [
      _c("div", { staticClass: "search-box-inner" }, [
        _c(
          "div",
          { staticClass: "input-group" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchString,
                  expression: "searchString"
                }
              ],
              ref: "searchInput",
              staticClass: "form-control searchField",
              attrs: {
                id: "searchField" + _vm.uid,
                type: "search",
                placeholder: "Suche",
                autofocus: _vm.isShopBuilder,
                name: "searchField",
                placeholder: _vm.$translate(
                  "Ceres::Template.headerSearchPlaceholder"
                ),
                "aria-label": _vm.$translate("Ceres::Template.headerSearchTerm")
              },
              domProps: { value: _vm.searchString },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchString = $event.target.value
                  },
                  function($event) {
                    return _vm.onValueChanged($event.target.value)
                  }
                ],
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.search()
                },
                focus: function($event) {
                  _vm.isSearchFocused = true
                  _vm.isOpen = true
                },
                blur: function($event) {
                  return _vm.onBlurSearchField($event)
                }
              }
            }),
            _vm._v(" "),
            _vm._t("search-button", function() {
              return [
                _c("span", { staticClass: "input-group-btn" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "search-submit px-3 btn-primary theme-sweets-online__search-button",
                      attrs: {
                        type: "submit",
                        "aria-label": _vm.$translate(
                          "Ceres::Template.headerSearch"
                        )
                      },
                      on: {
                        click: function($event) {
                          return _vm.search()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-search sm-up" })]
                  )
                ])
              ]
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      (_vm.isSearchFocused && !_vm.isMobile) || (_vm.isOpen && _vm.isMobile)
        ? [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (_vm.searchString.length >= _vm.searchMinLength &&
                        _vm.hasInitialInput) ||
                      _vm.$ceres.isShopBuilder,
                    expression:
                      "(searchString.length >= searchMinLength && hasInitialInput) || $ceres.isShopBuilder"
                  }
                ]
              },
              [
                _vm._t("autocomplete-suggestions", function() {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "autocomplete-suggestions shadow bg-white w-100 "
                      },
                      [
                        _c("div", { staticClass: "row position-relative" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 autocomplete-suggestions__headline"
                            },
                            [_vm._v("Suchergebnisse")]
                          ),
                          _vm._v(" "),
                          _vm.isMobile
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "autocomplete-suggestions__close",
                                  attrs: { "aria-hidden": "true" },
                                  on: {
                                    click: function($event) {
                                      _vm.isOpen = false
                                    }
                                  }
                                },
                                [_vm._v("×")]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row row__overflow" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-4 autocomplete-suggestions__left"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "autocomplete-suggestions__sub-headline autocomplete-suggestions__sub-headline--1"
                                },
                                [_vm._v("Vorschläge")]
                              ),
                              _vm._v(" "),
                              _c("search-suggestion-item", {
                                attrs: {
                                  "suggestion-type": "suggestion",
                                  "item-amount": 3
                                }
                              }),
                              _vm._v(" "),
                              !_vm.isMobile
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "autocomplete-suggestions__sub-headline autocomplete-suggestions__sub-headline--2"
                                    },
                                    [_vm._v("Kategorien")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isMobile
                                ? _c("search-suggestion-item", {
                                    attrs: {
                                      "suggestion-type": "category",
                                      "show-additional-information": true
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 col-md-8 autocomplete-suggestions__right"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "autocomplete-suggestions__sub-headline autocomplete-suggestions__sub-headline--3"
                                },
                                [_vm._v("Produkte")]
                              ),
                              _vm._v(" "),
                              _c("search-suggestion-item", {
                                attrs: {
                                  "show-images": true,
                                  "suggestion-type": "item"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 d-flex justify-content-center"
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-primary search-results__all",
                                  attrs: {
                                    href: "/search?query=" + _vm.searchString
                                  }
                                },
                                [_vm._v("Alle anzeigen")]
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ]
                })
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }